import { AlleleTableForm } from "../Enrollments/Search/components/AlleleTableForm";
import ReactDatePicker   from "react-datepicker";
import React from "react";
import { BPContainer } from "@/components/bp/bpcontainer";

export function DevIndex() {
    const [dateValue, setDateValue] = React.useState<Date | null>(new Date());

    return (
        <BPContainer>
            <h1>Development Components</h1>
            {/* <DialogDemo /> */}
            <AlleleTableForm value={{ kitId: null, systems: [] }} onChange={(values) => console.log(values)} />

            <h2>Date Picker</h2>
            <ReactDatePicker className={'w100'} isClearable={true} name={'datePicker'} 
            selected={dateValue} onChange={(date) => setDateValue(date)} />
            {/* <DatePicker selected={dateValue} selectsMultiple onChange={(date) => {
                console.log(date)
                return setDateValue(date as any);
            }} /> */}
        </BPContainer>
    );
}
